import { memo } from 'react';
import PropTypes from 'prop-types';
var OptimizelyVariation = function OptimizelyVariation(_ref) {
  var children = _ref.children;
  return children;
};
OptimizelyVariation.propTypes = {
  variationId: PropTypes.string.isRequired,
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.arrayOf(PropTypes.node)]),
  default: PropTypes.bool
};
OptimizelyVariation.defaultProps = {
  default: false,
  children: null
};
OptimizelyVariation.displayName = 'OptimizelyVariation';
var MemoOptimizelyVariation = /*#__PURE__*/memo(OptimizelyVariation);
export { MemoOptimizelyVariation as OptimizelyVariation };